import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import { useReactToPrint } from "react-to-print";
import html2pdf from "html2pdf.js";
import "../letterstyles/EmployeeIdCard.css";

const EmployeeIdCard = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const cardRef = useRef(null);
  const user = state?.user;
  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [company, setCompany] = useState(null);
  const [photoUrl, setPhotoUrl] = useState(null);

  useEffect(() => {
    if (!user) navigate("/");
  }, [user, navigate]);

  // Fetch company details
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/get-company?superAdminId=${superAdminId}`
        );
        const data = await res.json();
        if (res.ok && data) {
          if (data.logo)
            // data.logoUrl = `https://narrowitsolution.in/${data.logo.replace(/^images\//, "")}`;
          setCompany(data);
        }
      } catch (err) {
        console.error("Failed to fetch company details:", err);
      }
    };
    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  // Fetch employee photo
  useEffect(() => {
    const fetchPhoto = async () => {

      try {
        const res = await fetch(
          `https://narrowitsolution.in/api/list-employee-kyc?userId=${user?.userId}`
        );
        const data = await res.json();
        if (res.ok && data.documents?.length > 0) {
          const photoDoc = data.documents.find(
            (doc) => doc.docName?.toLowerCase() === "photo"
          );

          
      console.log("photoDoc.docImage");
      console.log(photoDoc.docImage);
          if (photoDoc?.docImage) {
            setPhotoUrl(`https://narrowitsolution.in/uploads/${photoDoc.docImage}`);
          }
        }
      } catch (err) {
        console.error("Failed to fetch employee photo:", err);
      }
    };
    if (user?.userId) fetchPhoto();
  }, [user]);

  // Format date to DD/MM/YYYY
  const formatDate = (dateStr) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };

  // // Print
  // const handlePrint = useReactToPrint({
  //   content: () => cardRef.current,
  //   documentTitle: `${user?.fullName || "Employee"}_ID_Card`,
  //   pageStyle: `
  //     @page { size: 55mm 90mm; margin: 0; }
  //     @media print { body { -webkit-print-color-adjust: exact; } }
  //   `,
  // });

  // Download PDF
  const handleDownload = () => {
    if (!cardRef.current) return;
    const opt = {
      margin: 0,
      filename: `${user?.fullName || "Employee"}_ID_Card.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 4, useCORS: true },
      jsPDF: { unit: "mm", format: [55, 90], orientation: "portrait" },
    };
    html2pdf().set(opt).from(cardRef.current).save();
  };

  if (!user) return null;

  return (
    <div className="idcard-wrapper">
      {/* Buttons (hidden in print) */}
      <div className="idcard-actions no-print">
        {/* <button className="idcard-btn" onClick={handlePrint}>🖨️ Print</button> */}
        <button className="idcard-btn" onClick={handleDownload}>⬇️ Download</button>
      </div>

      {/* ID Card */}
      <div className="idcard vertical" ref={cardRef}>
        {/* Top Header */}
        <div className="idcard-header-rect">
          {company?.logoUrl ? (
            <img
              src={company.logoUrl}
              alt="Company Logo"
              className="idcard-logo-rect"
              crossOrigin="anonymous"
            />
          ) : (
            <div className="idcard-logo-placeholder"></div>
          )}
          <span className="idcard-company-name">{company?.name || "Company Name"}</span>
          <span className="idcard-company-tagline">{company?.address || "Humara Sath aur Aapka Vishwas"}</span>
          <span className="idcard-company-tagline">{company?.domain || "Company Name"}</span>
        </div>

        {/* Curved Background + Photo */}
        <div className="idcard-photo-section">
          <div className="idcard-photo-curve"></div>
          <img
            src={photoUrl || "https://via.placeholder.com/120.png?text=Photo"}
            alt="Employee"
            className="idcard-photo-circle"
            crossOrigin="anonymous"
          />
        </div>

        {/* Name + Role */}
        <div className="idcard-employee-info">
          <h2 className="idcard-emp-name">{user.fullName}</h2>
          <h3 className="idcard-emp-role">{user.roleName}</h3>
        </div>

        {/* Details */}
        <div className="idcard-details-vertical">
          <div className="row"><span>EMPLOYEE ID</span><span>{user.userId || "--"}</span></div>
          <div className="row"><span>DATE OF BIRTH</span><span>{formatDate(user.dateOfBirth)}</span></div>
          <div className="row"><span>PHONE</span><span>{user.mobileNumber || "--"}</span></div>
          <div className="row"><span>DATE OF JOINING</span><span>{formatDate(user.dateOfJoining)}</span></div>
        </div>

        {/* Footer */}
        <div className="idcard-footer-rect">
          <div className="idcard-footer-contact">
            <span>Email: {company?.email || "email@company.com"}</span>
            <span>Phone: +91 {company?.contact || "+91-XXXXXXXXXX"}</span>
          </div>
          {/* <div className="idcard-sign-box"></div> */}
        </div>
      </div>
    </div>
  );
};

export default EmployeeIdCard;
